import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpLoadingService {
  loading$ = new BehaviorSubject<boolean>(false);

  public setValue(newValue: boolean) {
    this.loading$.next(newValue);
  }

  public showLoadingIndicator() {
    this.loading$.next(true);
  }

  public hideLoadingIndicator() {
    this.loading$.next(false);
  }
}
